import BaseListStyle from "../../styles/BaseListStyle"; 

const ExchangeRateProvidersStyles = (theme) => { 
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
  }
}

export default ExchangeRateProvidersStyles;
